module.exports = "/lucky-balls/img/weager/Stake_Holder.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/weager/Stake_Holder.png
// module id = 1172
// module chunks = 0